// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1iqMY","colCheckbox":"styles_colCheckbox__328ZC"};